// FE Supabase error reporter. Reports { data, error } failures from the
// instrumented Supabase client. Uses the eager Sentry import shared across
// the app — authProvider.ts already pulls @sentry/react into the entry bundle.

import type { SupabaseErrorReporter } from "@shared/supabase/instrumented";
import { Sentry } from "../sentry";

export const feSupabaseErrorReporter: SupabaseErrorReporter = (error, ctx) => {
  Sentry.captureException(
    Object.assign(new Error(error.message), { name: "SupabaseError" }),
    {
      tags: {
        ...(ctx.table ? { "supabase.table": ctx.table } : {}),
        ...(ctx.method ? { "supabase.method": ctx.method } : {}),
        ...(error.code ? { "supabase.code": error.code } : {}),
      },
      extra: {
        details: error.details,
        hint: error.hint,
      },
      level: "error",
    },
  );
};
